import React from 'react';
import PlayArrowRoundedIcon from '@mui/icons-material/PlayArrowRounded';
import PauseRoundedIcon from '@mui/icons-material/PauseRounded';
import CommonAvatar from '@src/new-components/Avatar';
import Typography from '@src/new-components/Typography';
import { StyledDemoCloningResultItem } from './index.style';

const DemoCloningResultItem = ({
  voiceName,
  voiceType,
  voiceAvatar,
  badgeIcon,
  isPlaying,
  currentPlayingVoiceType,
  onPlayingVoiceType,
}) => {
  const isAudioPlaying = isPlaying && currentPlayingVoiceType === voiceType;

  return (
    <StyledDemoCloningResultItem
      onClick={onPlayingVoiceType}
      isAudioPlaying={isAudioPlaying}
    >
      <div className="avatar-wrapper">
        <CommonAvatar
          avatar={voiceAvatar}
          badgeIcon={badgeIcon}
          size={48}
          styleBadgeIcon={{ height: '20px !important', bottom: '-10px' }}
        />
        {isAudioPlaying ? (
          <PauseRoundedIcon className="audio-icon" />
        ) : (
          <PlayArrowRoundedIcon className="audio-icon" />
        )}
      </div>
      <div className="result-info-wrapper">
        <Typography variant="body-14-bold" className="info">
          {voiceType}
        </Typography>
        <Typography variant="body-12-regular" className="info">
          {voiceName}
        </Typography>
      </div>
      <div className="overlay" />
    </StyledDemoCloningResultItem>
  );
};

export default DemoCloningResultItem;
